import { useRef, useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { parseAIRespose } from "../../utils/parseAIResponse";
import ProjectCards from "./ProjectCards";
import { FaEye, FaDownload } from 'react-icons/fa';


export default function ChatWindow({
  messages,
  SUGGESTIONS,
  input,
  setInput,
  sendMessage,
}) {
  const bottomRef = useRef(null);
  const textareaRef = useRef(null);

  // claude fix
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [input]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="absolute m-2  rounded-lg bottom-[60px] right-0 w-[340px] bg-[#202331] overflow-hidden shadow-md flex flex-col z-50">
      {/**header */}
      <div className="bg-[#978b72] flex items-center gap-4 p-2">
        <div className="w-8 text-sm h-8 rounded-full items-center justify-center flex bg-[#644d1b]">
          AI
        </div>
        <div className="flex flex-col items-center">
          <div className="agent-header-name self-start text-sm">MandlaAI</div>
          <div className="text-[#0f0d0b] text-[13px] mr-auto">
            <span className="inline-block w-[6px] h-[6px] rounded-md bg-[#1fff71] mr-[4px] animate-pulse 2s " />
            Online
          </div>
        </div>
      </div>

      {/**messages */}
      <div
        className="flex-1 p-2  overflow-y-auto p-14px flex flex-col gap-[10px] max-h-[320px] [&::-webkit-scrollbar]:w-1
  [&::-webkit-scrollbar-track]:bg-[#f2dbb9]
  [&::-webkit-scrollbar-thumb]:bg-[#978b72]
  [&::-webkit-scrollbar-thumb]:rounded-full"
      >
        {messages.map((message, index) => {
          const parsed =
            message.role === "assistant"
              ? parseAIRespose(message.content)
              : null;

          return (
            <div
              key={index}
              className={`flex flex-col text-sm gap-2px max-w-[85%] ${message.role === "assistant" ? "self-start" : "self-end"}`}
            >
              <div
                className={`p-[9px_13px] rounded-xl text-xs border overflow-hidden ${
                  message.role === "assistant"
                    ? "bg-[#1a1d2e] text-[#ccc8be] border-[#2a2d40]"
                    : "bg-[#6b6a5e] text-[#ece1cf] border-[#031153]"
                }`}
              >
                {message.role === "assistant" ? (
                  <>
                    <ReactMarkdown
                      components={{
                        p: ({ children }) => (
                          <p className="mb-2 last:mb-0">{children}</p>
                        ),
                        strong: ({ children }) => (
                          <strong className="font-semibold text-white">
                            {children}
                          </strong>
                        ),
                        ul: ({ children }) => (
                          <ul className="list-disc pl-4 mb-2 space-y-1">
                            {children}
                          </ul>
                        ),
                        ol: ({ children }) => (
                          <ol className="list-decimal pl-4 mb-2 space-y-1">
                            {children}
                          </ol>
                        ),
                        li: ({ children }) => (
                          <li className="leading-relaxed ">{children}</li>
                        ),
                        code: ({ children }) => (
                          <code className="bg-black/30 px-1 py-0.5 rounded text-[11px]">
                            {children}
                          </code>
                        ),
                        a: ({ href, children }) => (
                          <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-400 underline break-all"
                          >
                            {children}
                          </a>
                        ),
                      }}
                    >
                      {parsed.text}
                    </ReactMarkdown>

                    {parsed.projects.length > 0 && (
                      <ProjectCards projects={parsed.projects} />
                    )}

                    {parsed.matchBlog.length > 0 && (
                      <ProjectCards projects={parsed.matchBlog} />
                    )}

                    {parsed.downloadCV && (
                      <>
                        <a
                          href="/mandla_mbolekwa_resume.pdf"
                          download
                          className="flex items-center gap-2 mt-3 w-fit bg-[#1f4b69] shadow-2xl text-[#ece1cf] text-xs px-3 py-2 rounded-lg hover:bg-[#031153] transition"
                        >
                          <FaDownload />
                          Download CV
                        </a>
                      </>
                    )}
                  </>
                ) : (
                  <p>{message.content}</p>
                )}
                <div ref={bottomRef} />
              </div>
            </div>
          );
        })}

        {messages.length === 1 && (
          <div className="flex flex-wrap gap-[6px] pt-3">
            {SUGGESTIONS.map((s) => {
              return (
                <button
                  key={s}
                  onClick={() => sendMessage(s)}
                  className="border border-[#383b4e] text-xs text-[#978b72] rounded-[20px] p-[4px_10px] font-[11px] transition hover:border-[#978b72] duration-0.15s hover:text-[#ece1cf]"
                >
                  {s}
                </button>
              );
            })}
          </div>
        )}
      </div>
      <div className="flex gap-2 p-3 border-t border-[#3c3f4e] flex-shrink-0">
        <textarea
          ref={textareaRef}
          className="flex-1 bg-[#1a1d2e] border rounded-md border-[#2a2d40] p-[8px_12px] text-[#ece1cf] text-[13px] outline-none resize-none"
          rows={1}
          placeholder="Ask me anything..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          style={{ maxHeight: "120px", overflowY: "hidden" }}
        />
        <button
          onClick={() => sendMessage()}
          className="w-[36px] h-[36px] rounded-md bg-[#6b6a5e]  text-[#ece1cf] flex items-center justify-center flex-shrink-0 self-end"
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="22" y1="2" x2="11" y2="13" />
            <polygon points="22 2 15 22 11 13 2 9 22 2" />
          </svg>
        </button>
      </div>
    </div>
  );
}
